// utils.service.ts
import { Injectable } from "@angular/core";
import { InsurerDto, RefLanguageDto } from "src/app/api/models";
import { setErrorMsg } from "src/app/kiosk/components/error/state/error.actions";
import { environment } from "src/environments/environment";
import { eKioskError } from "../models/api/constants";
import { AppState } from "src/app/state/app.state";
import { Store } from "@ngrx/store";
import { ErrorLevel } from "src/app/kiosk/components/error/error-level";

@Injectable({
  providedIn: "root", // makes it available across the app
})
export class UtilsService {
  constructor(private store: Store<AppState>) {}

  public validateInsurerForKioskHomeProcess(insurer: InsurerDto,language: RefLanguageDto): boolean 
  {
    let kioskError: eKioskError;
    let blockProcess = false;
    let msgToDisplay: string;
    let noTranslate = false;
    let continueValidations = true;

    if ((environment.kioskMode && !insurer.kioskChannelAllowed) || (!environment.kioskMode && !insurer.homeChannelAllowed)) {
      if (environment.kioskMode)
        kioskError = eKioskError.INSURER_KIOSK_NOT_ALLOWED;
      else kioskError = eKioskError.INSURER_HOME_NOT_ALLOWED;

      blockProcess = true;
      continueValidations = false;
      if (insurer.questionnaireDeclarationsAllowed) {
        if (insurer.s1messageIdKioskForbiddenNavigation != null) {
          msgToDisplay = insurer.s1messageIdKioskForbiddenNavigation["text" + language.languageCode];
          noTranslate = true;
        }
      } else if (insurer.callCenterDeclarationsAllowed) {
        if (insurer.s5MessageIdContinueNavigation != null) {
          msgToDisplay = insurer.s5MessageIdContinueNavigation["text" + language.languageCode];
          noTranslate = true;
        }
      }
    }

    if (blockProcess) {
      if (msgToDisplay === null || msgToDisplay === undefined || msgToDisplay.trim() === ''){
        msgToDisplay = eKioskError[kioskError];
        noTranslate = false;
      }

      this.store.dispatch(
        setErrorMsg({data: msgToDisplay,noTranslation: noTranslate,KioskError: kioskError,errorLevel: ErrorLevel.WARNING,})
      );
      return false;
    }

    return true;
  }
}
